<template>
  <div class="boxCenter">
    <div class="topNavs mdx-flex mdx-row-between">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/workbench' }">工作台</el-breadcrumb-item>
        <el-breadcrumb-item>项目详情</el-breadcrumb-item>
      </el-breadcrumb>
      项目编号：{{ projectInfo.sn }}
    </div>
    <div class="conTBVox">
      <div class="listLines list1 wzk-cursor">
        <div class="" style="display: flex;">
          <div class="names line2 wzk-flex-1 w-m-b-20">
            {{ projectInfo.regionFy }}/{{ projectInfo.typeFy }}
            <template v-if="projectInfo.majorFyOne.length">
              <span v-for="(row, index) in projectInfo.majorFyOne" :key="index">/{{ row.name }}</span>
            </template>
            <span>
              /总投资:￥{{ projectInfo.totalInvestment || '00' }}
            </span>
            <span>
              /总规模:{{ projectInfo.totalScale }}m²
            </span>
            /{{ projectInfo.serviceContentFy }}
          </div>
          <div class="w-m-l-20">
            <!-- <span class="success">进行中</span> -->
            <div class="status error" v-if="projectInfo.status == 3 && projectInfo.zpEngineer == 1">
              未指派
            </div>
            <div class="status blue" v-if="projectInfo.status == 3 && projectInfo.zpEngineer == 2">
              工程师确认中
            </div>
            <div class="status error" v-if="projectInfo.status == 1">
              待审核
            </div>
            <div class="status" v-if="projectInfo.automaticTimeFy <= 0 && projectInfo.status == 2">
              已失效
            </div>
            <div class="status" v-else-if="projectInfo.status == 2">
              待付款
            </div>
            <div class="status blue" v-else-if="projectInfo.status == 4 && projectInfo.checkStatus == 1">
              成果待审核
            </div>
            <div class="status error" v-else-if="(projectInfo.status == 4 && projectInfo.checkStatus == 2) || (projectInfo.status == 4 && projectInfo.checkStatus == 5)">
              未通过
            </div>
            <div class="status blue" v-else-if="projectInfo.status == 4 && projectInfo.checkStatus == 3">
              待验收
            </div>
            <div v-else-if='projectInfo.status == 4' class="status blue">
              作业中
            </div>
            <div class="status blue" v-if="projectInfo.status == 5">
              已完成
            </div>
            <div class="status infoColor" v-if="projectInfo.status == 9">
              已取消
            </div>
            <div class="status blue" v-if="projectInfo.status == 6">
              投诉中
            </div>
            <!-- <span class="error">待审核</span> -->
          </div>
        </div>
        <div style="display: flex;">
          <div class="wzk-flex-1">
            <div class="tagsBox">
              <el-tag type="info" class="tags">{{ projectInfo.regionFy }}</el-tag>
              <el-tag type="info" class="tags" v-if="projectInfo.necessary == 1">需要出现场</el-tag>
              <el-tag type="info" class="tags" v-if="projectInfo.provided == 1">提供CAD图纸</el-tag>
              <el-tag type="info" class="tags">{{ projectInfo.typeFy }}</el-tag>
              <template v-if="projectInfo.majorFy.length">
                <el-tag type="info" class="tags" v-for="(row, index) in projectInfo.majorFy" :key="index + 'w'">
                  {{ row.name }}
                </el-tag>
              </template>
              <el-tag type="info" class="tags" v-if="projectInfo.serviceContentFy">{{ projectInfo.serviceContentFy }}
              </el-tag>
              <el-tag type="info" class="tags" v-for="(row, index) in projectInfo.softwareFy" :key="index + 'e'">
                {{ row.label }}
              </el-tag>
            </div>
            <div class="priceOrStatus">
              <span class="prices w-m-r-30" v-if="projectInfo.orderPrice">
                平台价格：{{ projectInfo.orderPrice || '' }}
              </span>
              <span class="prices w-m-r-30" v-if="projectInfo.earningsAmount">
                工程师收益：{{ projectInfo.earningsAmount || '' }}
              </span>
              <span class="prices w-m-r-30" v-if="projectInfo.depositAmount">
                工程师质保金：{{ projectInfo.depositAmount || '' }}
              </span>
              <span class="prices" v-if="!projectInfo.orderPrice">
                预估价格：{{ projectInfo.estimatedPrice || '' }}
              </span>
              <!-- <span class="prices w-m-l-30">
                预估价格：无
              </span> -->
              <!-- <span class="prices w-m-l-30">
                预估价格：无
              </span> -->
              <!-- <span class="w-m-l-20"> -->
              <!-- 固定总价 -->
              <!-- </span> -->
            </div>
            <div class="times">
              项目交付时间：{{ projectInfo.deliveryDeadline }}
            </div>
            <div class="times m-top-10">
              工程师成果交付时间：{{ projectInfo.engineerDeadline }}
            </div>
            <div class="btLines">
              <span>项目类型</span>
              <el-tag type="info" class="tags">{{ projectInfo.typeFy }}</el-tag>
            </div>
            <div class="btLines">
              <span>所含专业</span>
              <el-tag type="info" class="tags" v-for="(item, index) in projectInfo.majorFy" :key="index + 'm'">
                {{ item.name }}
              </el-tag>
            </div>
            <div class="btLines">
              <span>服务内容</span>
              <el-tag type="info" class="tags">{{ projectInfo.serviceContentFy }}</el-tag>
            </div>
            <div class="btLines">
              <span>要求软件</span>
              <el-tag type="info" class="tags" v-for="(item, index) in projectInfo.softwareFy" :key="index + 's'">
                {{ item.label }}
              </el-tag>
            </div>
            <div class="btLines">
              <span>总投资：</span>{{ '￥' + projectInfo.totalInvestment }}
            </div>
            <div class="btLines">
              <span>总规模：</span>{{ projectInfo.totalScale }}m²
            </div>
            <div class="btLines">
              <span>总占地面积：</span>{{ projectInfo.totalArea }}m²
            </div>
          </div>
          <div v-if="projectInfo.engineerInfo.id">
            <div class="jinliBox">
              <div class="titels">
                工程师
              </div>
              <div class="mdx-flex namebox">
                <WzkAvatar :imgSrc="projectInfo.engineerInfo.headImgUrl"></WzkAvatar>
                <span class="username">{{ $mHelper.nameSlice(2, userInfo, projectInfo.engineerInfo.name,
                    projectInfo.engineerInfo.name)
                }}</span>
              </div>
              <div class="infoBox" v-if="projectInfo.engineerInfo.mobile">
                <div>电话</div>{{ projectInfo.engineerInfo.mobile || '' }}
              </div>
              <div class="infoBox" v-if="projectInfo.engineerInfo.qq">
                <div>QQ</div>{{ projectInfo.engineerInfo.qq || '' }}
              </div>
              <div class="infoBox" v-if="projectInfo.engineerInfo.mailbox">
                <div>邮箱</div>{{ projectInfo.engineerInfo.mailbox || '' }}
              </div>
            </div>
          </div>
          <div class="w-m-l-20" v-if="projectInfo.customerInfo.id">
            <div class="jinliBox">
              <div class="titels">
                客户
              </div>
              <div class="mdx-flex namebox">
                <WzkAvatar :imgSrc="projectInfo.customerInfo.headImgUrl"></WzkAvatar>
                <span class="username">{{ $mHelper.nameSlice(1, userInfo, projectInfo.customerInfo.name,
                    projectInfo.customerInfo.name)
                }}
                </span>
              </div>
              <div class="infoBox" v-if="projectInfo.customerInfo.mobile">
                <div>电话</div>{{ projectInfo.customerInfo.mobile || '' }}
              </div>
              <div class="infoBox" v-if="projectInfo.customerInfo.qq">
                <div>QQ</div>{{ projectInfo.customerInfo.qq || '' }}
              </div>
              <div class="infoBox" v-if="projectInfo.customerInfo.mailbox">
                <div>邮箱</div>{{ projectInfo.customerInfo.mailbox || '' }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="conTBVox" style="margin-top: 30px;">
      <h3>项目描述：</h3>
      <div class="miaoshu">
        {{ projectInfo.remark || '无' }}
      </div>
    </div>
    <div class="conTBVox" style="margin-top: 30px;" v-if="projectInfo.files.length > 0">
      <h3>附件资料：</h3>
      <div class="miaoshu mdx-flex mdx-row-around mdx-flex-wrap">
        <div v-for="(item, index) in projectInfo.files" :key='index'>
          <img style="height: 80px;" src="../../../static/images/fileIcon.png">
          <div style="margin-top: 10px; width: 85px;margin: auto;" class="line1 mdx-text-center">
            {{ item.name || '' }}
          </div>
          <el-button type="primary" class="downFile" size="mini" @click="viewCad(item)" v-if="item.name.includes('dwg')">查看</el-button>
          <el-button type="primary" plain class="downFile" size="mini" :loading="item.downloadStatus"
            @click="downloadFile(item, index, 1)">
            下载资料</el-button>
        </div>
        <template v-if="projectInfo.files % 5 != 0">
          <div v-for="(item, index) in (5 - (projectInfo.files.length % 5))" :key="index + 'o'">
          </div>
        </template>
      </div>
    </div>
    <div class="conTBVox" style="margin-top: 30px;" v-if="projectInfo.supplyFiles.length > 0">
      <h3>补充资料：</h3>
      <div class="miaoshu mdx-flex mdx-row-around mdx-flex-wrap">
        <div v-for="(item, index) in projectInfo.supplyFiles" :key='index'>
          <img style="height: 80px;" src="../../../static/images/fileIcon.png">
          <div style="margin-top: 10px; width: 85px;margin: auto;" class="line1 mdx-text-center">
            {{ item.name || '' }}
          </div>
          <el-button type="primary" plain class="downFile" size="mini" @click="downloadFile(item, index, 2)">下载资料
          </el-button>
        </div>
        <template v-if="projectInfo.supplyFiles % 5 != 0">
          <div v-for="(item, index) in (5 - (projectInfo.supplyFiles.length % 5))" :key="index + 'p'">
          </div>
        </template>
      </div>
    </div>
    <div class="conTBVox" style="margin-top: 30px;"
      v-if="projectInfo.status != 1 && projectInfo.status != 2 && projectInfo.status != 4">
      <div class="mdx-flex mdx-row-between">
        <h3>报名列表：</h3>
        <el-button size="small" type="primary" v-if="projectInfo.status == 3 && projectInfo.zpEngineer == 1"
          style="background-color: #007AFF;" @click="inviteShow = true;">邀请工程师
        </el-button>
      </div>
      <div class="listbox">
        <div class="listLines list2 wzk-cursor" @click="toDetails(1)" v-for="(item, index) in bmList" :key='index'>
          <div class="mdx-flex">
            <WzkAvatar :isGender="true" :gender="item.gender || 1" :imgSrc="item.headImgUrl"></WzkAvatar>
            <span class="username">{{ $mHelper.nameSlice(2, userInfo, item.name, item.name) }}</span>
            <span class="number">{{ item.engineerNo || '' }}</span>
            <div class="wzk-flex-1">
            </div>
            <div>
              <span class="w-m-l-30" style="color: #007AFF;">
                <i class="wzk-dianhuatianchong wzk"></i>
                {{ item.mobile || '' }}
              </span>
            </div>
            <div class="w-m-l-10">
              <el-button size="mini" type="primary" v-if="item.jurisdiction == 1" @click="OpenTakeBack(item, 2)">收回权限
              </el-button>
              <el-button size="mini" v-if="item.jurisdiction == 2" @click="OpenTakeBack(item, 1)">开放权限</el-button>
            </div>
          </div>
          <div class="conBox">
            <div class="lfetInfo wzk-flex-1">
              <div class="lfetInfo_lines">
                <div class="lfetInfo_lines_title">项目类型</div>
                <div class="wzk-flex-1">
                  <el-tag type="info" class="tags" v-for="(item, index) in item.typeFy" :key="index + 'q'">{{ item.label
                  }}
                  </el-tag>
                </div>
              </div>
              <div class="lfetInfo_lines">
                <div class="lfetInfo_lines_title">擅长软件</div>
                <div class="wzk-flex-1">
                  <el-tag type="info" class="tags" v-for="(item, index) in item.softwareFy" :key="index + 'w'">
                    {{ item.label }}
                  </el-tag>
                </div>
              </div>
              <div class="lfetInfo_lines">
                <div class="lfetInfo_lines_title">擅长地区</div>
                <div class="wzk-flex-1">
                  <el-tag type="info" class="tags" v-for="(item, index) in item.regionFy" :key="index + 'e'">{{
                      item.name
                  }}
                  </el-tag>
                  <el-tag type="info" class="tags">天津</el-tag>
                </div>
              </div>
              <div class="lfetInfo_lines">
                <div class="lfetInfo_lines_title">擅长专业</div>
                <div class="wzk-flex-1">
                  <el-tag type="info" class="tags" v-for="(item, index) in item.majorFy" :key="index + 'r'">{{ item.name
                  }}
                  </el-tag>
                </div>
              </div>
            </div>
            <div class="rightBox">
              <div class="rightBox_lines">
                <div class="numbers">{{ item.favorable }}</div>
                <div class="text">好评率</div>
              </div>
              <div class="rightBox_lines">
                <div class="numbers">{{ item.completed || 0 }}</div>
                <div class="text">已完成</div>
              </div>
              <div class="rightBox_lines">
                <div class="numbers">{{ item.timeliness }}</div>
                <div class="text">及时率</div>
              </div>
              <div class="rightBox_lines">
                <div class="numbers" v-if="item.excellent">{{item.excellent}}%</div>
                <div class="numbers" v-else>--</div>
                <div class="text">优秀率</div>
              </div>
              <div class="rightBox_lines">
                <div class="numbers">{{ item.reputation }}</div>
                <div class="text">信誉值</div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="conTBVox" style="margin-top: 30px;display: flex;" v-if="projectInfo.engineerInfo.id">
      <div class="wzk-flex-1">
        <h3>工程师：</h3>
        <div class="w-m-l-20 w-m-t-30">
          <div class="mdx-flex namebox">
            <WzkAvatar :imgSrc="projectInfo.engineerInfo.headImgUrl"></WzkAvatar>
            <span class="username w-m-l-20">{{ $mHelper.nameSlice(1, userInfo, projectInfo.engineerInfo.name,
                projectInfo.engineerInfo.name)
            }}
            </span>
            <span class="w-m-l-30" style="color: #007AFF;">
              <i class="wzk-dianhuatianchong wzk"></i>
              {{ projectInfo.engineerInfo.mobile || '' }}
            </span>
          </div>
          <div class="w-m-l-70 w-m-t-20 error">
            <span>
              工程师收益：￥{{ projectInfo.earningsAmount || 0 }}
            </span>

          </div>
          <div class="w-m-l-70 w-font-12 blue w-m-t-30">
            提交截止时间：{{ projectInfo.engineerDeadline }}
          </div>
        </div>
      </div>
      <div class="rightjieguo" v-if="projectInfo.engineerInfo.engineerFiles.length">
        <div class="mdx-flex">
          <h3>工程师成果：</h3>
          <div class="times wzk-flex-1">
            <!-- <span class="error">
              上传时间：{{ projectInfo.engineerInfo.engineerFiles.at(-1).createDate }}
            </span> -->
            <span class="error">
              上传时间：{{ getLastFileTime(1) }}
            </span>
          </div>
          <span class="wzk-cursor jieguoBtn" @click="cgShow = true">
            历史成果
          </span>
        </div>
        <div class="miaoshu mdx-flex mdx-row-around mdx-flex-wrap">
          <div style="width: 92px;margin-top: 10px;">
            <img style="height: 80px;" src="../../../static/images/fileIcon.png">
            <div style="margin-top: 10px; width: 100%;">
              工程师成果文件.zip
            </div>
            <!-- :loading="loadEnginFruit" -->
            <el-button type="primary" plain class="downFile" size="mini" :loading="loadEngiFruit"
              @click="downloadEngineerFruit">下载资料</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="conTBVox" style="margin-top: 30px;display: flex;" v-if="projectInfo.progressList.length">
      <div class="wzk-flex-1">
        <h3>项目进展：</h3>
        <div class="evolvebxo">
          <div v-for="(item, index) in projectInfo.progressList" :key='index'>
            {{ item.title }} {{ item.createTime }}
            <el-tooltip :content="item.content" placement="top" effect="light">
              <span style="color: #185BA1;cursor: pointer;" v-if="item.content">详情</span>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="rightjieguo" v-if="projectInfo.projectFiles.length">
        <div class="mdx-flex">
          <h3>项目成果：</h3>
          <div class="times wzk-flex-1">
            上传时间：{{ getLastFileTime(2) }}
          </div>
          <!-- <span class="wzk-cursor jieguoBtn">
            历史成果
          </span> -->
        </div>
        <div class="miaoshu mdx-flex mdx-row-around mdx-flex-wrap">
          <div style="width: 92px;margin-top: 40px;">
            <img style="height: 80px;" src="../../../static/images/fileIcon.png">
            <div style="margin-top: 10px; width: 100%;">
              项目成果文件.zip
            </div>
            <el-button type="primary" plain class="downFile" size="mini" :loading="loadFruit" @click="downWenjianCg">
              下载资料</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="conTBVox" style="margin-top: 30px;" v-if="projectInfo.engineerInfo.id">
      <h3>留言板：</h3>
      <div class="w-m-t-20">
        <el-radio v-model="radio" :label="1">所有人可见</el-radio>
        <el-radio v-model="radio" :label="2">需求方可见</el-radio>
        <el-radio v-model="radio" :label="3">工程师可见</el-radio>
      </div>
      <div class="w-m-t-10">
        <el-input type="textarea" :rows="8" placeholder="请输入内容" v-model.trim="textarea">
        </el-input>
      </div>
      <div class="w-m-t-10 mdx-flex mdx-row-right">
        <el-button type="primary" style="padding: 10px 40px;" size="mini" @click="saveMsgTap()">发布</el-button>
      </div>
    </div>
    <div class="conTBVox" style="margin-top: 30px;" v-for="(item, index) in msgList" :key="index">
      <div class="mdx-flex liuyanList">
        <WzkAvatar :imgSrc="item.headImgUrl" :borderRadius='50'></WzkAvatar>
        <div class="w-m-l-10">
          <div>
            {{ $mHelper.nameSlice(item.identity, userInfo, item.nickname, item.name) }} <span v-if="item.identity == 1">
              (需求方)
            </span>
            <span v-if="item.identity == 2">
              (工程师)
            </span>
            <span v-if="item.identity == 3">
              (项目经理)
            </span>
          </div>
          <div class="w-m-t-5 times">
            {{ item.createTime }}
          </div>
        </div>
      </div>
      <div class="w-p-l-60 w-m-t-10">
        {{ item.content }}
      </div>
      <div class="blue w-font-14 mdx-text-right w-m-t-10" v-if="userInfo.identity == 3">
        <span v-if="item.type == 1">
          所有人可见
        </span>
        <span v-if="item.type == 2">
          客户可见
        </span>
        <span v-if="item.type == 3">
          工程师可见
        </span>
      </div>
    </div>
    <div class="mdx-flex mdx-row-center " style="margin-top: 30px;" v-if="msgList.length">
      <el-pagination :pageSize="queryParams.limit" :currentPage='queryParams.page' background layout="prev, pager, next"
        @current-change='pageChange' :page-count="queryParams.totalPage || 1">
      </el-pagination>
    </div>
    <el-dialog :visible.sync="cgShow" width="40%" center top='20vh'>
      <div class="puopContext w-font-13">
        <div class="mdx-text-center">
          <h3>历史成果</h3>
        </div>
        <div v-for="(item, index) in projectInfo.engineerInfo.engineerFiles" :key='index'>
          <div class="titmeTitles w-font-14">
            {{ item.createDate }}
          </div>
          <div class="mdx-flex w-m-t-10">
            <div class="wzk-flex-1 mdx-text-center">
              <img src="../../../static/images/fileIcon.png" height="85px">
            </div>
            <div class="wzk-flex-1 " style="text-align: center;">
              <div style="margin-top: 10px;width: 100%;text-align: center; " class="line1">
                {{ item.name }}
              </div>
              <el-button type="primary" plain class="downFile" size="mini" @click="downItemOnleyChengguo(item)">下载资料
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="inviteShow" show-cancel-button :before-close='handleClose' width="40%" center top='20vh'>
      <div class="mdx-text-center">
        <h3>邀请工程师申请此项目</h3>
      </div>
      <div class="puopContext  w-m-t-30  w-font-16">
        <div class="mdx-flex">
          <div class="">
            工程师编号
          </div>
          <div class="wzk-flex-1 w-m-l-20">
            <el-input style="margin-top: 0;" type="text" placeholder="请输入工程师编号" v-model.trim="engineerNo">
            </el-input>
          </div>
        </div>
        <div class="mdx-flex mdx-row-center w-m-t-30">
          <el-button type="primary" style="padding: 10px 40px;border-radius: 2px;" class="" :loading="loading"
            @click.stop="inviteTap()">
            邀请
          </el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      v-if="cadShow"
      :visible.sync="cadShow"
      width="80%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="() => cadShow = false">
      <div id='map-container' v-loading="cadLoading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255, 255, 255, 0.8)">
      </div>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="cadShow = false">确 定</el-button>
      </span> -->
    </el-dialog>
  </div>
</template>

<script>
import WzkAvatar from '../../../components/wzk-Avatar/index.vue'
import { initNumberValue } from "@/common/utils/num-validate.js"
import vjmap from 'vjmap'; 
import 'vjmap/dist/vjmap.min.css' // 样式一定要引用！！！
export default {
  components: {
    WzkAvatar
  },
  data() {
    return {
      inviteShow: false,
      engineerNo: '',
      cgShow: false,
      radio: 1,
      imgSrc: 'https://img2.baidu.com/it/u=1953922700,4041156140&fm=26&fmt=auto',
      titleShow: false,
      puopShow: false,
      textarea: '',
      Id: null,
      projectInfo: {
        totalInvestment: '',
        majorFyOne: [],
        majorFy: [],
        files: [],
        supplyFiles: [],
        progressList: [],
        projectFiles: [],
        customerInfo: {},
        engineerInfo: {
          engineerFiles: [],
        },
      },
      bmList: [],
      msgList: [],
      queryParams: {
        page: 1, //当前页数
        limit: 10, //每页条数
        totalPage: 1
      },
      loading: false,
      loadFruit: false,
      loadEngiFruit: false,
      cadShow:false,
      cadLoading:false
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters['userInfo']
    }
  },
  created() {
    this.Id = this.$route.query.id || null
    if (!this.Id) {
      this.$message.error('参数错误')
      return
    }
    this.getDetail();
  },
  methods: {
    async viewCad(item){
        this.cadShow = true;
        this.cadLoading = true;
        let splitArr = item.url.split('.');
        let splitArr2 = (splitArr[splitArr.length-2]).split('/');
        let filterMapid = splitArr2[splitArr2.length-1];
        // --通过网络路径打开地图--传入DWG路径的http路径打开DWG图
        // js代码
        // 新建地图服务对象，传入服务地址和token
        const env = {
            serviceUrl: "https://vjmap.com/server/api/v1",
            accessToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJJRCI6MiwiVXNlcm5hbWUiOiJhZG1pbjEiLCJOaWNrTmFtZSI6ImFkbWluMSIsIkF1dGhvcml0eUlkIjoiYWRtaW4iLCJCdWZmZXJUaW1lIjo4NjQwMCwiZXhwIjoxOTQyMzg5NTc0LCJpc3MiOiJ2am1hcCIsIm5iZiI6MTYyNzAyODU3NH0.VQchVXxgjl5aCp3j3Uf5U2Mpk1NJNirH62Ys-8XOfnY",
            exampleMapId: "sys_zp"
        };
        let svc = new vjmap.Service(env.serviceUrl, env.accessToken)
        // 打开地图
        // 地图ID (如果换成了您自定义的url地址，记得修改此名称id，改成您想要的唯一的名称即可)
        const mapid = filterMapid;
        // 地图url地址，注意：url地址后四个字母必须为.dwg。如果实际中的地址四4位不是.dwg可以随便加个参数如 url?param=xxx&filetype=.dwg
        // const httpDwgUrl = "http://o2o-web.oss-cn-beijing.aliyuncs.com/Sample.dwg" ;
        // https://gczjzb-1308562443.cos.ap-nanjing.myqcloud.com/file/30481654501597257.dwg
        const httpDwgUrl = item.url;
        let res = await svc.openMap({
            // (第一次打开此地图ID时，会根据fileid去获取dwg路径打开，之后会读取缓存打开)
            mapid: mapid, // 地图ID
            fileid: httpDwgUrl,
            mapopenway: vjmap.MapOpenWay.GeomRender, // 以几何数据渲染方式打开
            style: vjmap.openMapDarkStyle() // div为深色背景颜色时，这里也传深色背景样式
        })
        
        /*
        “(第一次打开此地图ID时，会根据fileid去获取dwg路径打开，之后会读取缓存打开)” 的意思是
          举例来说，您第一次打开的图的时候用的是
        {
        mapid: 'map1',
        fileid: 'http://127.0.0.1/1.dwg'
        }
        这时候因为后台没有 map1 这个图纸，所以第一次时 map1 就会去下载 'http://127.0.0.1/1.dwg'
        打开图。
        但是，您第二次的时候如果要换成另外的图2.dwg，但是如果还是用同样的mapid的话，如
        {
        mapid: 'map1',
        fileid: 'http://127.0.0.1/2.dwg'
        }
        这时候为了性能，后台不会再去下载2.dwg了，就直接用之前的下载并处理好的图的缓存数据了。
        这时候有两个选择。
        (1) 要么是updateMap去更新图。
        (2) 要么就重新命名一个新的 mapid 如map2
        */
        if (res.error) {
            message.error(res.error)
        }
        // 获取地图的范围
        let mapExtent = vjmap.GeoBounds.fromString(res.bounds);
        // 建立坐标系
        let prj = new vjmap.GeoProjection(mapExtent);
        console.log('res',res);
        // // 新建地图对象
        // console.log('map',new vjmap())
        let map = new vjmap.Map({
            container: 'map-container', // container ID
            style: svc.rasterStyle(), // 样式，这里是栅格样式,// 矢量瓦片样式
            center: prj.toLngLat(mapExtent.center()), // 中心点
            zoom: 2,
            renderWorldCopies: false
        });
       
        // 地图关联服务对象和坐标系
        map.attach(svc, prj);
        // 使地图全部可见
        map.fitMapBounds();
        await map.onLoad();
        this.cadLoading = false;
    },
    //获取详情
    getDetail() {
      this.$http.get('project/detail', {
        id: this.Id
      }).then(res => {
        if (res.code == 200) {
          res.data.totalInvestment = initNumberValue(res.data.totalInvestment)
          res.data.totalScale = initNumberValue(res.data.totalScale)
          res.data.totalArea = initNumberValue(res.data.totalArea)
          res.data.orderPrice = initNumberValue(res.data.orderPrice)
          res.data.earningsAmount = initNumberValue(res.data.earningsAmount)
          res.data.depositAmount = initNumberValue(res.data.depositAmount)
          res.data.estimatedPrice = initNumberValue(res.data.estimatedPrice)
          res.data.files.forEach(function (item) {
            item.downloadStatus = false
          })
          res.data.supplyFiles.forEach(function (item) {
            item.downloadStatus = false
          })
          this.projectInfo = res.data
          this.bmListGet();
          this.getMesList() //获取留言列表
        }
      })
    },
    getLastFileTime(type) {
      var _time = "";
      try {
        if (type==1) {
          var _index = this.projectInfo.engineerInfo.engineerFiles.length - 1;
          if (this.projectInfo.engineerInfo.engineerFiles[_index]) {
            _time = this.projectInfo.engineerInfo.engineerFiles[_index].createDate;
          }
        } else {
          var _index = this.projectInfo.projectFiles.length - 1;
          if (this.projectInfo.projectFiles[_index]) {
            _time = this.projectInfo.projectFiles[_index].createDate;
          }
        }
      } catch (error) {}
      return _time;
    },
    bmListGet() {
      this.$http.get('director/bmList', {
        id: this.Id,
        pageNum: 1,
        pageSize: 999
      }).then(res => {
        if (res.code == 200) {
          this.bmList = res.data.list
        }
      })
    },
    //权限
    OpenTakeBack(item, type) {
      this.$http.post('director/permissionSet', {
        projectId: this.Id,
        type: type,
        engineerId: item.id
      }).then(res => {
        if (res.code == 200) {
          this.$message.success('操作成功')
          this.bmListGet();
        }
      })
    },
    saveMsgTap() {
      if (!this.textarea) {
        this.$message.error('请输入留言内容')
        return
      }
      this.$http.post('project/saveMsg', {
        type: this.radio,
        projectId: this.Id,
        content: this.textarea
      }).then(res => {
        if (res.code == 200) {
          this.$message.success('留言成功')
          this.textarea = ''
          this.getMesList()
        }
      })
    },
    pageChange(e) {
      this.queryParams.page = e
      this.getMesList()
    },
    getMesList() {
      this.$http.post('project/listMsg', {
        projectId: this.Id,
        pageNum: this.queryParams.page,
        pageSize: this.queryParams.limit
      }).then(res => {
        if (res.code == 200) {
          this.queryParams.totalPage = res.data.pages
          this.msgList = res.data.list
        }
      })
    },
    downItemOnleyChengguo(item) {
      this.loading = true
      this.$http.downloadFile('upload/download', {
        fileId: item.id,
        projectId: this.Id
      }).then(res => {
        var reader = new FileReader();
        let that = this
        reader.onloadend = function (event) {
          //因为返回的报错格式是字符串，手动转换成对象，转换成功表示请求失败
          //转换失败就意味着你拿到的result是文件流，那么直接手动下载就好
          this.loading = false
          console.log(res)
          try {
            let data = JSON.parse(event.target.result)
            that.$message.error(res.data.msg);
          } catch (err) {
            const link = document.createElement('a'); // 创建a标签
            let blob = new Blob([res.data]);
            link.style.display = 'none';
            link.href = URL.createObjectURL(blob); // 创建下载的链接
            link.setAttribute('download', item.name); // 给下载后的文件命名
            document.body.appendChild(link);
            link.click(); // 点击下载
            document.body.removeChild(link); //  完成移除元素
            window.URL.revokeObjectURL(link.href); // 释放blob对象
            that.materialsShow = false;
          }
        };
        reader.readAsText(res.data);
      }).catch(err => {
        this.loading = false
      })
    },
    //下载项目成果 release/batchDownload
    downWenjianCg() {
      this.loadFruit = true
      this.$http.downloadFile('release/batchDownload', {
        id: this.Id
      }).then(res => {
        this.loadFruit = false;
        var reader = new FileReader();
        let that = this
        reader.onloadend = function (event) {
          //因为返回的报错格式是字符串，手动转换成对象，转换成功表示请求失败
          //转换失败就意味着你拿到的result是文件流，那么直接手动下载就好
          console.log(res)
          try {
            let data = JSON.parse(event.target.result)
            that.$message.error(res.data.msg);
          } catch (err) {
            const link = document.createElement('a'); // 创建a标签
            let blob = new Blob([res.data]);
            link.style.display = 'none';
            link.href = URL.createObjectURL(blob); // 创建下载的链接

            link.setAttribute('download', '项目成果文件.zip'); // 给下载后的文件命名
            document.body.appendChild(link);
            link.click(); // 点击下载
            document.body.removeChild(link); //  完成移除元素
            window.URL.revokeObjectURL(link.href); // 释放blob对象
            that.materialsShow = false;
          }
        };
        reader.readAsText(res.data);
      }).catch(err => {
        this.loadFruit = false;
      })
    },
    //下载工程师成果 director/download
    downloadEngineerFruit() {
      this.loadEngiFruit = true
      this.$http.downloadFile('director/download', {
        id: this.Id
      }).then(res => {
        this.loadEngiFruit = false
        var reader = new FileReader();
        let that = this
        reader.onloadend = function (event) {
          //因为返回的报错格式是字符串，手动转换成对象，转换成功表示请求失败
          //转换失败就意味着你拿到的result是文件流，那么直接手动下载就好
          console.log(res)
          try {
            let data = JSON.parse(event.target.result)
            that.$message.error(res.data.msg);
          } catch (err) {
            const link = document.createElement('a'); // 创建a标签
            let blob = new Blob([res.data]);
            link.style.display = 'none';
            link.href = URL.createObjectURL(blob); // 创建下载的链接

            link.setAttribute('download', '工程师成果文件.zip'); // 给下载后的文件命名
            document.body.appendChild(link);
            link.click(); // 点击下载
            document.body.removeChild(link); //  完成移除元素
            window.URL.revokeObjectURL(link.href); // 释放blob对象
            that.materialsShow = false;
          }
        };
        reader.readAsText(res.data);
      }).catch(err => {
        this.loadEngiFruit = false
      })
    },
    downloadFile_origin(item, index, type) {
      this.loading = true
      this.$http.downloadFile('upload/download', {
        fileId: item.id,
        projectId: this.Id
      }).then(res => {
        console.log(res)
        this.loading = false
        if (res.data.type === 'application/force-download') {
          const link = document.createElement('a'); // 创建a标签
          let blob = new Blob([res.data]);
          link.style.display = 'none';
          link.href = URL.createObjectURL(blob); // 创建下载的链接
          link.setAttribute('download', item.name); // 给下载后的文件命名
          document.body.appendChild(link);
          link.click(); // 点击下载
          document.body.removeChild(link); //  完成移除元素
          window.URL.revokeObjectURL(link.href); // 释放blob对象
          this.loading = false
          this.materialsShow = false;
        } else {
          // 将blob文件流转换成json
          let _that = this;
          const reader = new FileReader()
          reader.onload = function (event) {
            let data = JSON.parse(event.target.result);
            if (data && data.hasOwnProperty('msg')) {
              _that.$message.error(data.msg);
            }
          }
          reader.readAsText(res.data)
        }
      }).catch(err => {
        console.log(err)
        this.loading = false
        //console.log(err)
        let _that = this;
        if (err.data.type === "application/json") {
          const reader = new FileReader()
          reader.onload = function (event) {
            let data = JSON.parse(event.target.result);
            console.log(data)
            if (data && data.hasOwnProperty('msg')) {
              _that.$message.error(data.msg);
            }
          }
          reader.readAsText(err.data)
        }
      })
    },
    downloadFile(item, index, type) {
      if (this.userInfo.identity != 3 && this.projectInfo.fgJurisdiction != 1) {
        this.$message.error('暂无权限')
        return;
      }
      //this.loading = true
      if (type == 1) {
        //附件资料下载
        this.projectInfo.files[index].downloadStatus = true;
      } else {
        //补充资料下载
        this.projectInfo.supplyFiles[index].downloadStatus = true;
      }
      this.$http.downloadFile('upload/download', {
        fileId: item.id,
        projectId: this.Id
      }).then(res => {
        console.log(res)
        //this.loading = false
        var reader = new FileReader();
        let that = this
        reader.onloadend = function (event) {
          //因为返回的报错格式是字符串，手动转换成对象，转换成功表示请求失败
          //转换失败就意味着你拿到的result是文件流，那么直接手动下载就好
          try {
            let data = JSON.parse(event.target.result)
            console.log(data)
            that.$message.error("请点击右上角登录后重新下载");
            //this.loading = false
            if (type == 1) {
              that.projectInfo.files[index].downloadStatus = false;
            } else {
              that.projectInfo.supplyFiles[index].downloadStatus = false;
            }
          } catch (err) {
            const link = document.createElement('a'); // 创建a标签
            let blob = new Blob([res.data]);
            link.style.display = 'none';
            link.href = URL.createObjectURL(blob); // 创建下载的链接
            link.setAttribute('download', item.name); // 给下载后的文件命名
            document.body.appendChild(link);
            link.click(); // 点击下载
            document.body.removeChild(link); //  完成移除元素
            window.URL.revokeObjectURL(link.href); // 释放blob对象
            //this.loading = false
            if (type == 1) {
              that.projectInfo.files[index].downloadStatus = false;
            } else {
              that.projectInfo.supplyFiles[index].downloadStatus = false;
            }
            that.materialsShow = false;
          }
        };
        reader.readAsText(res.data);
      }).catch(err => {
        console.log(err)
        // this.loading = false
        if (type == 1) {
          //附件资料下载
          this.projectInfo.files[index].downloadStatus = false;
        } else {
          //补充资料下载
          this.projectInfo.supplyFiles[index].downloadStatus = false;
        }
      })

    },
    //邀请工程师
    inviteTap() {
      if (!this.engineerNo) {
        this.$message.error('请输入工程师编号')
        return;
      }
      this.loading = true;
      this.$http.post('/director/invitation', {
        engineerNo: this.engineerNo,
        projectId: this.Id
      }).then(res => {
        this.loading = false
        if (res.code == 200) {
          this.inviteShow = false;
          const h1 = this.$createElement;
          this.$msgbox({
            title: '提示',
            message: h1('p', {
              style: 'margin-bottom: 20px'
            }, [
              h1('span', null, '您已成功邀请工程师申请此项目！ '),
              h1('br', {
                style: 'color: red'
              }, ''),
              h1('span', null, '如此工程师同意申请，则会出现在项目申请列表中！ '),
            ]),
            center: true,
            showCancelButton: true,
            showConfirmButton: false,
            cancelButtonText: '我知道了',
          })
        }
      }).catch(err => {
        this.loading = false
      })

    },
    //邀请工程师面板关闭
    handleClose() {
      this.inviteShow = false;
      console.log('邀请工程师面板关闭')
    }
  }
}
</script>

<style lang="scss" scoped>
#map-container {
    width: 100%;
    height:800px;
    background: #000000;
}
::v-deep .el-dialog{
  margin-top:6vh!important;
}
::v-deep .el-dialog__footer{
  text-align: center;
}
.liuyanList {
  span {
    color: #185BA1;
    margin-left: 0px;
  }
}

.times {
  font-size: 14px;
  color: #757575;
}

.evolvebxo {
  border: 1px solid #CCCCCC;
  height: 262px;
  margin-top: 10px;
  padding: 10px;
  box-sizing: border-box;
  overflow-y: scroll;

  >div {
    background-color: #EEEEEE;
    margin-bottom: 10px;
    font-size: 14px;
    padding: 10px;
  }
}

.rightjieguo {
  width: 36%;

  .times {
    font-size: 13px;
    color: #757575;
  }

  .jieguoBtn {
    color: #007AFF;
    font-weight: 400;
    font-size: 16px;
  }
}

.bzjBox {
  background-color: #DCEAFF;
  padding: 20px 15px;
  box-sizing: border-box;
  border-radius: 5px;
  margin-left: 20px;
}

.jinliBox {
  background-color: #DCEAFF;
  width: 241px;
  border-radius: 5px;
  padding: 20px 15px;
  box-sizing: border-box;

  .namebox {
    margin-top: 15px;
  }

  .username {
    margin-left: 20px;
    font-size: 18px;
  }

  .titels {
    font-size: 14px;
    font-weight: 550;

  }

  .infoBox {
    font-size: 14px;
    margin-top: 15px;
    display: flex;
    align-items: center;

    >div {
      width: 40px;
    }
  }
}

.puopContext {
  >div {
    line-height: 30px;
  }
}

::v-deep .el-dialog--center .el-dialog__body {
  padding-top: 5px;
}

.subimtBtmn {
  margin-top: 30px;
  text-align: center;

  &_btn {
    padding: 15px 100px;
    font-size: 18px;
  }
}

.topNavs {
  margin: 20px 0;
}

.conTBVox {
  border-radius: 5px;
  padding: 20px;
  box-sizing: border-box;
  background-color: #FFFFFF;
}

.miaoshu {
  margin-top: 20px;
  font-size: 14px;
  color: #757575;

  >div {
    margin-bottom: 30px;
    width: 20%;
    text-align: center;
  }

  .downFile {
    margin-top: 10px;
    // background-color: #fff;
  }
}

.listLines {
  background-color: #fff;
  background-color: #fff;
  box-sizing: border-box;

  .names {
    font-size: 16px;
  }

  .times {
    font-size: 14px;
    color: #757575;
  }

  .m-top-10 {
    margin-top: 10px;
  }

  .btLines {
    margin-top: 10px;
    font-size: 16px;

    span {
      margin-right: 10px;
    }
  }

  .tags {

    background: #EEEEEE;
    color: #757575;
    margin-right: 15px;
    height: 28px;
    line-height: 28px;
  }
}

.list1 {
  .times {
    font-size: 14px;
    color: #757575;
  }

  .tagsBox {
    margin-top: 20px;
  }

  .priceOrStatus {
    line-height: 60px;

    .prices {
      font-size: 22px;
      font-weight: 550;
      color: #FF3B30;
    }

    .status {
      margin-left: 30px;
      font-size: 14px;
      color: #FF3B30;
    }
  }
}

/*滚动条样式*/
::v-deep ::-webkit-scrollbar {
  width: 10px;
  /*height: 4px;*/
}

::v-deep ::-webkit-scrollbar-thumb {
  border-radius: 2px;
  -webkit-box-shadow: inset 0 0 5px rgba(200, 200, 200, 0.2);
  background: #185BA1;
  ;
}

::v-deep ::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);

}

.listbox {
  background-color: #fff;
  padding-bottom: 30px;
  margin-top: 30px;
}

.listLines {
  border-bottom: 1px solid #ddd;
  background-color: #fff;
  // margin-top: 20px;
  background-color: #fff;
  padding: 20px 0;
  box-sizing: border-box;

  .names {
    font-size: 16px;
  }

  .times {
    font-size: 14px;
    color: #757575;
  }

  .tags {
    background: #EEEEEE;
    color: #757575;
    margin-right: 15px;
    height: 28px;
    line-height: 28px;
  }
}

.list2 {
  .username {
    margin-left: 20px;
    font-size: 18px;
    font-weight: 550;
  }

  .number {
    margin-left: 20px;
  }

  .addrss {
    font-size: 14px;
    margin-left: 20px;
    color: #666666;
  }

  .conBox {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .lfetInfo_lines {
      display: flex;
      // align-items: center;
      margin-top: 10px;

      .lfetInfo_lines_title {
        margin-top: 2px;
        width: 110px;
        text-align: right;
        margin-right: 20px;
      }
    }
  }

  .rightBox {
    display: flex;

    .rightBox_lines {
      padding: 0 20px;
      text-align: center;

      .numbers {
        font-size: 36px;
        font-weight: 550;
      }
    }

    .text {
      margin-top: 10px;
      font-size: 16px;
    }
  }
}
</style>
